(function () {
    'use strict';

// @ngInject
    Models.MemberReferralModel = function MemberReferralModel(BaseModel) {

        return Class(BaseModel, {

            constructor: function MemberReferralModel() {
                this.constructor.$super.call(this);
                this.__className = 'MemberReferralModel';
            },

            mapChilds: function mapChilds() {
                return {};
            },

            afterMixingFrom: function afterMixingFrom(object) {
            },

            isCachable: function isCachable() {
                return true;
            }
        });
    };
}());

